export const categoriesComputed = {
  computed: {
    categoriesElStyles() {
      const { textColor } = this.module.config.general;
      const styles = {
        color: textColor.value,
      };

      return styles;
    },
    getJobCountForCategory() {
      return (categoryTitle) => {
        const found =
          this.jobCounts &&
          this.jobCounts.find((count) => count.value === categoryTitle);
        return found ? found.jobsText : this.zeroJobsText;
      };
    },
  },
  props: {
    jobCounts: {
      type: Array,
      default() {
        return [{ value: "IT", count: 0, jobsText: "0 jobs" }];
      },
    },
    zeroJobsText: {
      type: String,
      default: "",
    },
  },
};
